import { LANGUAGE_MAP } from 'constant/language';
import DisputeInfo from '../components/dispute-info';
import { ContractLang, ContractStyleType } from '../utils';
import classNames from 'classnames';
import dayjs from 'dayjs';

const ReturnContractFooter = ({
  contractLang,
  storeName,
  contractStyleType,
  isStoreCopy,
}: {
  contractLang: ContractLang;
  storeName: string;
  contractStyleType: ContractStyleType;
  isStoreCopy: boolean;
}) => {
  const tipsEl = (() => {
    if (contractLang === LANGUAGE_MAP.JA) {
      return (
        <>
          当店では商品の取扱いには細心の注意を払っておりますが、
          万一お届けいたしました商品に不備がございました場合には、商品到着後
          すぐにお電話、またはメールにてご連絡ください。
          <br />
          また、不良品以外の返品・交換は致しかねますので、
          あらかじめご了承ください下さいますようお願い申し上げます。
          <br />
          <br />
          またのご利用をお待ちしております。ありがとうございました。
        </>
      );
    }

    if (contractLang === LANGUAGE_MAP.FR) {
      return (
        <>
          Nous apportons le plus grand soin à la manipulation des produits.
          Toutefois, en cas de défaut, veuillez nous contacter par téléphone ou
          par e-mail dès réception.
          <br />
          Veuillez noter que nous n&apos;acceptons pas les retours ou échanges
          pour d&apos;autres raisons que les défauts du produit. Merci de votre
          compréhension.
          <br />
          <br />
          Nous espérons vous servir à nouveau.
        </>
      );
    }

    if (contractLang === LANGUAGE_MAP.EN) {
      return (
        <>
          We take the utmost care in handling the products. However, in the
          unlikely event that you receive a defective item, please contact us by
          phone or email immediately after the product arrives.
          <br />
          Please note that we do not accept returns or exchanges for reasons
          other than product defects. Thank you for your understanding.
          <br />
          <br />
          We look forward to serving you again.
        </>
      );
    }

    if (contractLang === LANGUAGE_MAP.ZH_CN) {
      return (
        <>
          我们会以最谨慎的态度处理商品。但若您收到的商品出现瑕疵，
          请在商品送达后立即通过电话或电子邮件与我们联系。
          <br />
          请注意，除商品本身存在瑕疵外，我们不接受其他原因的退换货申请。感谢您的理解与配合。
          <br />
          <br />
          期待再次为您服务。
        </>
      );
    }
  })();

  return (
    <>
      <DisputeInfo contractLang={contractLang} storeName={storeName} />
      <div className="border-l border-r px-2 py-2 shrink-0">
        <div className="text-xs">
          {tipsEl}
          {isStoreCopy && (
            <div className="flex justify-between mt-4">
              <div>
                {
                  {
                    [LANGUAGE_MAP.EN]: 'I have received the above item.',
                    [LANGUAGE_MAP.JA]: '上記お品物を受け取りました。',
                    [LANGUAGE_MAP.ZH_CN]: '我已收到上述商品。',
                    [LANGUAGE_MAP.FR]: "J'ai reçu le(s) article(s) ci-dessus.",
                  }[contractLang]
                }
              </div>
              <div
                className={classNames(
                  'relative mb-1 w-1/2 min-h-[48px] flex justify-between items-end pb-1',
                )}
                style={{ borderBottom: 'double' }}
              >
                <span>
                  {
                    {
                      [LANGUAGE_MAP.EN]: 'Signature',
                      [LANGUAGE_MAP.JA]: '名前',
                      [LANGUAGE_MAP.ZH_CN]: '签名:',
                      [LANGUAGE_MAP.FR]: 'Signature',
                    }[contractLang]
                  }
                </span>
                {contractLang === LANGUAGE_MAP.JA && <span>印</span>}
              </div>
            </div>
          )}
          <div className="text-right">{dayjs().format('YYYY/MM/DD')}</div>
        </div>
      </div>

      <div
        className={classNames(
          'text-lg px-1 shrink-0',
          contractStyleType === 'white'
            ? 'bg-white text-black border'
            : 'bg-black text-white',
        )}
        style={{ printColorAdjust: 'exact' }}
      >
        {storeName.toUpperCase()}
      </div>
    </>
  );
};

export default ReturnContractFooter;
